import React, { useState } from 'react'
import "./DisableReason.css"
import getDisableDetails from './getDisableDetails'
import DisablePopUp from './DisablePopUp'
import { dateTimeFormat } from '../../utils/Misc/DateTime'
import disableIcon from '../../images/disable.png'
const DisableReason = ({ disableDetails }) => {
    const { disabledReason, description } = getDisableDetails(disableDetails?.GLUSR_DISABLE_ERRMSG_VALUE);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    return (
        <>
            <img src={disableIcon} alt="DisableIcon" className='disable-icon' onClick={handleOpenModal} onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave} />
            {
                isHovered && <div className="disable-icon-text">Listing Suppressed</div>
            }
            {isModalOpen && (
                <DisablePopUp
                    onClose={handleCloseModal}
                    disabledDate={dateTimeFormat(disableDetails?.GLUSR_DISABLE_ERRMSG_DATE)}
                    disabledReason={disabledReason}
                    description={description}
                />
            )}
        </>
    )
}

export default DisableReason;